import { render, staticRenderFns } from "./Ask.vue?vue&type=template&id=d9eae012&scoped=true&"
import script from "./Ask.vue?vue&type=script&lang=js&"
export * from "./Ask.vue?vue&type=script&lang=js&"
import style0 from "./Ask.vue?vue&type=style&index=0&id=d9eae012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9eae012",
  null
  
)

export default component.exports